import styled from 'styled-components';

const NavButtonContainer = styled.div`
  user-select: none;
  background-image: url(${props => props.background});
  height: 32px;
  width: 18px;
  &:after {
    display: none;
  }
`;

export default NavButtonContainer;
